module.exports = __webpack_public_path__ + "static/media/better-yourself-2.3e065abe.jpg";